module.exports = __webpack_public_path__ + "static/media/persona_3.cae4672c.png";